import { ArrowUpRight, Check } from "lucide-react";
import { SITE } from "../../content";
import { Eyebrow, Reveal } from "./Primitives";

const POINTS = [
  "Für jedes Alter und jedes Schwimmniveau geeignet",
  "Individuelle Übungen und persönliche Betreuung",
  "Verbesserung von Technik & Wasserlage",
  "Kraultechnik & Atmung gezielt trainieren",
  "Vorbereitung auf Schwimmabzeichen oder persönliche Ziele",
];

export const PrivateLessons = () => (
  <section id="privatstunden" data-testid="private-lessons-section" className="bg-white py-24 sm:py-32">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <Reveal className="lg:col-span-6">
        <Eyebrow>Privatstunden</Eyebrow>
        <h2 className="mt-6 text-4xl font-extrabold leading-[1.05] tracking-[-0.02em] text-navy sm:text-5xl">
          Individuelle Förderung. <span className="font-light italic text-sky-700">Ganz persönlich.</span>
        </h2>
        <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-600 md:text-lg">
          Ob Schwimmanfänger, Technik verbessern oder gezielt an Kraulen, Brust- oder Rückenschwimmen arbeiten – im Privatunterricht steht ganz das persönliche Ziel im Mittelpunkt.
        </p>
        <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-600 md:text-lg">
          Gemeinsam arbeiten wir an Wassergewöhnung, Sicherheit im Wasser, Technik, Atmung, Ausdauer oder an der Vorbereitung auf ein Schwimmabzeichen.
        </p>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-5 lg:col-start-8">
        <div className="border border-navy/10 bg-ice p-7 sm:p-10">
          <ul className="space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex gap-3 text-base text-navy">
                <Check className="mt-1 h-4 w-4 shrink-0 text-sky-600" /> {p}
              </li>
            ))}
          </ul>
          <a
            href={SITE.privateBookingUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="private-lessons-book-btn"
            className="group mt-10 flex items-center justify-between rounded-full bg-navy px-7 py-4 text-sm font-bold text-white transition-colors duration-300 hover:bg-navy-700"
          >
            Privatstunde buchen
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
